// extracted by mini-css-extract-plugin
export var actions = "_6p-8";
export var arrow = "_6p-5";
export var card = "_6p-0";
export var cardWrapper = "_6p-9";
export var fieldName = "_6p-3";
export var newValue = "_6p-6";
export var oldValue = "_6p-4";
export var orangeGlowFade = "_6p-c";
export var productSection = "_6p-1";
export var scrollToBottom = "_6p-b";
export var scrollToBottomAnchor = "_6p-a";
export var scrollToBottomIcon = "_6p-d";
export var showAllButton = "_6p-7";
export var table = "_6p-2";